<div class="forms-page">
  <app-header-views
    [title]="'Builder'"
    (actionButton)="actionButtonNew()"
    [textButton]="'Form'"
  ></app-header-views>
  <div class="content-view">
   
    <app-sub-sidebar
      [tamMinWidhtSibSidebar]="210"
      [tamWidhtSibSidebar]="250"
      [tamHeightSibSidebar]="170"
      (searchText)="searchSidebar($event)"
    >     
      <div class="cards">
        <p class="not-found-text" *ngIf="!loading && forms?.length == 0">No forms found</p>
        <div
          class="card"
          *ngFor="let form of forms | search : search"
          (click)="selectForm(form)"
          [ngClass]="{ 'card-selected': formSelected?.sk === form.sk }"
        >
          <div class="content">
            <span class="name"> {{ form.name | titlecase }} </span>
            <span class="date">
              <strong>Created:</strong>
              {{ form.created_at | date : "medium" }}
            </span>
            <span class="date">
              <strong>Edited:</strong>
              {{ form.updated_at | date : "medium" }}
            </span>
          </div>
          <div class="settings" (click)="deleteForm(form)">
            <mat-icon>delete</mat-icon>
          </div>
        </div>
      </div>
    </app-sub-sidebar>

    <div class="view">
      <!-- -- loading->{{loading}}<br>
      -- formSelected->{{formSelected?.sk}}<br>
      -- versionSelected->{{versionSelected?.sk}}<br>
      -- elementSelected->{{elementSelected?.sk}}<br>
      -- type->{{elementSelected?.pk}}<br>
      -- isNewForm->{{isNewForm}}<br>
      -- versionSelectedId->{{versionSelectedId}}<br> -->
      <div
        class="mg-no-form-container"
        *ngIf="!loading && !formSelected?.sk && !isNewForm"
      >
        <span
          (click)="actionButtonNew()"
          class="material-symbols-outlined mg-no-form-icon"
        >
          add_notes
        </span>
        <!--  <mat-icon class="">list_alt_add</mat-icon> -->
        <span class="mg-no-form-text"
          >No form selected. Please select or create one</span
        >
      </div>

      <div class="content-selected" *ngIf="elementSelected?.sk || isNewForm">
        <div class="view__title">
          <div class="titles" *ngIf="!isNewForm">
            <span
              class="title__general"
              [title]="elementSelected?.name || 'Untitled Form'"
              >{{ elementSelected?.name || "Untitled Form" }}
            </span>
            <span class="title_id"
              ><strong>ID:</strong> {{ elementSelected!.sk }} | 
              <span *ngIf="elementSelected!.pk == 'form'" class="badge bg-info">Form</span>          
              <span *ngIf="elementSelected!.pk == 'version'" class="badge bg-danger">Version</span>          
              <span *ngIf="elementSelected!.pk == 'form'"> | <strong>Versions:</strong>
                {{ versions.length }}
              </span>
              <span *ngIf="elementSelected!.pk == 'version'"> | <strong>Created:</strong>
                {{ elementSelected.created_at | date : "medium" }}
              </span>
            </span>          
          </div>
          <div class="titles" *ngIf="isNewForm">
            <span class="title__general" title="Untitled Form"
              >Untitled Form
            </span>
          </div>
          <div class="versions" *ngIf="!isNewForm && elementSelected">
            <div class="versions_style">
              <span class="versions_title">Versions </span>
              <div class="dropdown">
                <ng-select style="min-width: 210px;"
                placeholder="Select an option" 
                [items]="versions"
                bindValue="sk"
                bindLabel="created_at"
                [(ngModel)]="versionSelectedId"
                (change)="selectVersion()"
                (keydown)="selectVersion()" 
                (keyup)="selectVersion()"
                >
                <ng-template ng-option-tmp ng-label-tmp let-item="item">
                  {{ item.created_at | date:"MMM dd, yyyy 'at' hh:mm a" }}
               </ng-template>
                </ng-select>
              </div>
            </div>
          </div>

          <div class="buttons" *ngIf="!isNewForm && elementSelected && elementSelected!.pk == 'version'">
            <button (click)="selectForm(formSelected)" class="btn-style flex justify-content-center align-items-center me-1">
              <span class="material-symbols-outlined icon-style">
                arrow_left_alt
              </span>
              <span class="text-sm">Back to Form</span>
            </button>
          </div>
          <!-- --{{changes}}--
          --{{viewSelected}}-- -->
          <div class="tabs">
            <app-tabs
              [tabs]="tabs"
              [blocked]="changes"
              [view]="viewSelected"
              (activeTab)="activeTab($event)"
            ></app-tabs>
          </div>
        </div>
        <div class="view__content" [ngSwitch]="viewSelected">
          <app-general
            (edit)="changedDetected($event)"
            *ngSwitchCase="'1'"
          ></app-general>
          <app-data-table 
            *ngSwitchCase="'2'"
            ></app-data-table>
          <app-layout 
            (changed)="changedDetected($event)"
            *ngSwitchCase="'3'">            
          </app-layout>          
          <app-launch *ngSwitchCase="'4'"></app-launch>
          <app-template *ngSwitchCase="'5'"></app-template>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Single loading, but separate  variables it allows in futures have separates loading indicators per action -->
<!-- <div *ngIf="loadingListForm || loadingGetForm || loadingDeleteForm || loadingCreateForm || loadingUpdateForm || loadingCreateVersion || loadingDeleteVersion || loadingUpdateVersion || loadingListValue || loadingGetValue || loadingCloneForm" class="loading-style"> -->
<div *ngIf="loading" class="loading-style">
  <app-loading-spinner></app-loading-spinner>
</div>
